"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

class Search extends _react.default.Component {
  constructor(props) {
    super(props);
    const minWidth = this.props.minWidth;
    this.state = {
      hover: false
    };
    this.open = {
      width: minWidth > 355 ? minWidth + 'px' : '305px',
      marginLeft: minWidth > 355 ? '-' + (minWidth - 50) + 'px' : '-255px'
    };
    this.closed = {
      width: '40px',
      marginLeft: '0'
    };
    this.handleHover = this.handleHoverEvent.bind(this);
  }
  getStyle(prop) {
    if (this.props.isMobile) {
      // Always closed if isMobile
      return this.closed[prop];
    }
    return this[this.props.searchOpen ? 'open' : 'closed'][prop];
  }
  handleHoverEvent() {
    this.setState({
      hover: !this.state.hover
    });
  }
  render() {
    const minWidth = this.props.minWidth;
    this.open = {
      width: minWidth > 355 ? minWidth + 50 + 'px' : '305px',
      marginLeft: minWidth > 355 ? '-' + (minWidth + 10) + 'px' : '-255px'
    };
    if (!this.props.hasSearch) {
      return false;
    }
    const searchBoxStyles = {
      position: 'relative',
      width: '40px',
      height: '47px',
      margin: '14px 0 14px'
    };
    const searchSliderStyles = {
      width: this.getStyle('width'),
      height: '47px',
      marginLeft: this.getStyle('marginLeft'),
      backgroundColor: '#000',
      overflow: 'hidden',
      transition: 'all 0.25s ease-in-out'
    };
    const inputStyles = {
      margin: 0,
      padding: '11px 6px 6px',
      display: 'inline-block',
      textDecoration: 'none',
      fontSize: '20px',
      lineHeight: '19px',
      fontWeight: 100,
      color: '#fff',
      outline: 'none',
      maxWidth: '200px',
      backgroundColor: '#000',
      border: 'none'
    };
    const buttonStyles = {
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50%',
      backgroundImage: 'url(https://www.concur.com/sites/all/modules/custom_concur/concur_search/images/ico-arrow.png)',
      boxShadow: 'none',
      padding: '9px 25px 11px',
      margin: 0,
      minWidth: 0,
      marginTop: '-8px'
    };
    buttonStyles.backgroundColor = this.state.hover ? '#92cb53' : '#89bf42';
    return /*#__PURE__*/_react.default.createElement("div", {
      style: searchBoxStyles,
      className: "menu-search-box pull-right"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-search-slider",
      style: searchSliderStyles
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-search-form",
      style: {
        width: '305px',
        marginLeft: this.props.searchOpen ? parseInt(this.open.width, 10) - 305 + 'px' : 0,
        transition: 'all 0.25s ease-in-out'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        backgroundImage: 'url(https://www.concur.com/sites/all/modules/custom_concur/concur_search/images/ico-search.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50%',
        cursor: 'pointer',
        height: '48px',
        width: '39px',
        float: 'left',
        display: this.props.open && this.props.isMobile ? 'none' : 'block'
      },
      className: "toggle-search",
      onClick: this.props.toggleSearch
    }), /*#__PURE__*/_react.default.createElement("form", {
      id: "menu-search-form",
      action: '/search',
      style: {
        float: 'left',
        display: this.props.open && this.props.isMobile ? 'none' : 'block'
      }
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: "e-search-input",
      name: "sqs",
      size: "30",
      maxLength: "128",
      placeholder: this.props.placeholder,
      style: inputStyles
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "submit",
      name: "submit",
      onMouseEnter: this.handleHover,
      onMouseLeave: this.handleHover,
      className: "btn light-green bg-icon",
      value: "",
      style: buttonStyles
    })))));
  }
}
exports.default = Search;
Search.propTypes = {
  placeholder: _propTypes.default.string,
  minWidth: _propTypes.default.number,
  hasSearch: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  open: _propTypes.default.bool,
  searchOpen: _propTypes.default.bool,
  toggleSearch: _propTypes.default.func
};
Search.defaultProps = {
  placeholder: 'Search',
  hasSearch: false
};